module.exports = __webpack_public_path__ + "img/infant.17a6dce3.svg";